<div class="title-section skeleton-loader"></div>
<table *ngIf="loaderType === 'grid'">
  <tr *ngFor="let row of dummyRow; let i = index" [ngClass]="{'skeleton-loader' : i%2 !== 0}"></tr>
</table>
